import { c as _c } from "react/compiler-runtime";
import { useDashboardPathname as usePathname } from "@/hooks/useDashboardNavigation";

/**
 * First URL segment for routes that are not `/[org]/…` org-scoped pages.
 * If we treated these as org names (e.g. `/codesmith-autofix-configuration` →
 * org "codesmith-autofix-configuration"), prefetch and
 * metrics APIs would hit the wrong path and error.
 *
 * When adding a new top-level route, include its path segment here.
 */
const RESERVED_TOP_LEVEL_SEGMENTS = new Set(["admin", "analytics", "autofix-settings", "cache", "cli", "codesmith-autofix-configuration", "copy-prompt", "docker-analytics", "enable-autofix", "extension", "github-actions-analytics", "logs", "machine-definitions", "monitors", "rightsize", "runs", "sessions", "settings", "stickydisks", "support", "testboxes", "usage", "welcome"]);
export function useOrgFromPathname() {
  const $ = _c(4);
  const pathname = usePathname();
  if (!pathname) {
    return;
  }
  let first;
  let t0;
  let t1;
  if ($[0] !== pathname) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const segments = pathname.split("/").filter(Boolean);
      first = segments[0];
      if (!first) {
        t1 = undefined;
        break bb0;
      }
      t0 = RESERVED_TOP_LEVEL_SEGMENTS.has(first.toLowerCase());
    }
    $[0] = pathname;
    $[1] = first;
    $[2] = t0;
    $[3] = t1;
  } else {
    first = $[1];
    t0 = $[2];
    t1 = $[3];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  if (t0) {
    return;
  }
  return first;
}